import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { sortOrder } from "app/atoms/utils.atom";

/**
 * Syncs the sort order from Jotai (localStorage) to a cookie so server loaders
 * can read it on initial page load. The primary persistence is localStorage via
 * atomWithStorage; the cookie is only for server-side fallback.
 */
export function SortOrderSync() {
  const value = useAtomValue(sortOrder);

  useEffect(() => {
    if (typeof document !== "undefined" && value) {
      document.cookie = `sortOrder=${value}; path=/; max-age=31536000`;
    }
  }, [value]);

  return null;
}
